import React from "react";
import PageBanner from "@/components/PageBanner";

export default function LegalLayout({ title, seoKey, children }) {
  return (
    <div data-testid="legal-page" className="bg-white">
      <PageBanner pageKey="legal" seoKey={seoKey} eyebrow="Legal" title={title} titleTestId="legal-page-title" />
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 pb-16 sm:pb-24 pt-10 sm:pt-0">
        <div className="prose text-[var(--brand-secondary)] leading-relaxed space-y-4">{children}</div>
      </div>
    </div>
  );
}
